import CustomerInformationUploadModalComponent from './component';
export default class CustomerInformationUploadModalRoute extends CustomerInformationUploadModalComponent {}
